import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  toolbarButtons: {
    height: 50,
    width: 50,
    margin: theme.spacing(1),
    borderRadius: "5em",
    backgroundColor: theme.palette.info.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.info.dark,
    },
  },
}));
